import { Layout } from '@/components/layout/Layout';
import { Hero } from '@/components/home/Hero';
import { ProductsShowcase } from '@/components/home/ProductsShowcase';
import { Features } from '@/components/home/Features';
import { DiscordCTA } from '@/components/home/DiscordCTA';
import { Team } from '@/components/home/Team';
import { Partners } from '@/components/home/Partners';
import { Contact } from '@/components/home/Contact';
import { CTA } from '@/components/home/CTA';
import { SEOHead } from '@/components/SEOHead';
import { BASE_URL } from '@/lib/seo';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'DeinServerHost',
    url: BASE_URL,
    logo: `${BASE_URL}/faviconBig.png`,
    description: 'Prepaid server hosting since 2013 – Game servers, VPS, Dedicated Servers, Web Hosting without contracts.',
    foundingDate: '2013',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      availableLanguage: ['German', 'English'],
    },
    sameAs: [
      'https://discord.gg/deinserverhost',
      'https://twitter.com/Deinserverhost',
      'https://www.facebook.com/DeinServerHost/',
      'https://www.instagram.com/deinserverhost/',
      'https://www.tiktok.com/@deinserverhost',
      'https://youtube.com/@deinserverhost',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'DeinServerHost',
    url: `${BASE_URL}/`,
  },
];

export default function HomePage() {
  return (
    <Layout>
      <SEOHead
        title="Prepaid Game Servers, VPS & Dedicated"
        description="Prepaid hosting since 2013: game servers, VPS, dedicated servers and web hosting with DDoS protection from €1.00/month. No minimum contract."
        canonical="/"
        schema={homeSchema}
      />
      <Hero />
      <ProductsShowcase />
      <Features />
      <DiscordCTA />
      <Partners />
      <Team />
      <CTA />
    </Layout>
  );
}
